import React from "react";

const tooltips = {
    "46_note_tag": "note tag is a short label used to categorize and filter daily log entries. Toggle tags to quickly view related notes.",
    // Add other keys as needed
};

export function getTooltip(key) {
    return tooltips[key] || "";
}

export function Tooltip({ text }) {
    return (
        <span
            style={{
                marginLeft: 4,
                verticalAlign: "middle",
                cursor: "pointer",
                color: "#fff"
            }}
            title={text}
        >
            🛈
        </span>
    );
}